import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import FitPulseLogo from "./FitPulseLogo";

const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <motion.nav
      data-testid="navigation-bar"
      className="fixed top-0 left-0 right-0 z-50 transition-all duration-300"
      style={{
        backgroundColor: scrolled ? "rgba(255,255,255,0.85)" : "rgba(255,255,255,0.95)",
        backdropFilter: scrolled ? "blur(20px)" : "none",
        borderBottom: scrolled ? "1px solid #E5E5E5" : "1px solid transparent",
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16">
        <a href="/" className="flex items-center gap-2.5" data-testid="nav-logo">
          <FitPulseLogo size={28} />
          <span className="text-[#0D0D0D] font-bold text-lg tracking-tight">FitPulse</span>
        </a>

        <motion.a
          data-testid="nav-download-button"
          href="https://play.google.com/store"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-[#0D0D0D] text-white text-sm font-semibold px-5 py-2.5 rounded-full hover:bg-black transition-colors"
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.97 }}
          animate={{
            boxShadow: [
              "0 0 0 0 rgba(13,13,13,0)",
              "0 0 0 6px rgba(13,13,13,0.08)",
              "0 0 0 0 rgba(13,13,13,0)",
            ],
          }}
          transition={{
            boxShadow: { duration: 2, repeat: Infinity, repeatDelay: 2 },
            scale: { duration: 0.15 },
          }}
        >
          Download Free
        </motion.a>
      </div>
    </motion.nav>
  );
};

export default Navigation;
